import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
  Link, ThemeContext, Avatar, Coins, CoinsPackModal,
} from '../../common';
import CoinsIcon from '../../../assets/coins_small.jpg';
import {updateUserCoins} from '../../../actions/user';

const UserSection = ({
  ableToSendGiftsForFree, user, onLogout, coins, onUpdateUserCoins,
}) => {
  const {fullName, image} = user;

  const [isPopupOpen, setPopupOpen] = React.useState(false);
  const onPopupClose = () => setPopupOpen(false);
  const onPopupOpen = () => setPopupOpen(true);

  const [isCoinPacksModalOpen, setCoinPacksModalOpen] = React.useState(false);
  const onCoinPacksModalClose = () => setCoinPacksModalOpen(false);
  const onCoinPacksModalOpen = () => {setPopupOpen(false); setCoinPacksModalOpen(true);};

  return (
    <ThemeContext.Consumer>
      {(theme) => {
        const userNameColor = {
          color: theme.secondaryColor,
        };
        const {primaryColor: linkColor} = theme;
        const paymentPacks = Object.keys(theme.paymentPacks).map(key => theme.paymentPacks[key]);

        return (
          <div className="header__user user">
            <div className="user__avatar">
              <Avatar image={image} fullName={fullName} iconSize="36" imageWidth={100}/>
            </div>
            <div className="user__links">
              <span style={userNameColor} className="user__name" title={fullName}>{fullName}</span>
              <ul className="menu menu_delimiter" style={{color: linkColor}}>
                <li className="menu-item">
                  <Link to="/profile" text="Profile"/>
                </li>
                <li className="menu-item">
                  <Link onClick={onLogout} text="Sign out"/>
                </li>
              </ul>
            </div>
            <button
              className="button_icon"
              type="button"
              onClick={onPopupOpen}
            >
              <img src={CoinsIcon} alt="Coins" width={30}/>
            </button>
            {isPopupOpen && (
              <Coins
                ableToSendGiftsForFree={ableToSendGiftsForFree}
                coins={coins}
                onCoinPacksModalOpen={onCoinPacksModalOpen}
                onClickOutside={onPopupClose}
                updateUserCoins={onUpdateUserCoins}
              />
            )}
            {paymentPacks && (
              <CoinsPackModal
                isModalOpened={isCoinPacksModalOpen}
                onModalClose={onCoinPacksModalClose}
                paymentPacks={paymentPacks}
                updateUserCoins={onUpdateUserCoins}
              />
            )}

          </div>
        );
      }}
    </ThemeContext.Consumer>
  );
};

UserSection.propTypes = {
  ableToSendGiftsForFree: PropTypes.bool.isRequired,
  coins: PropTypes.shape({}).isRequired,
  user: PropTypes.shape({
    fullName: PropTypes.string,
    image: PropTypes.string,
  }).isRequired,
  onLogout: PropTypes.func.isRequired,
  onUpdateUserCoins: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const {
    user: {coins},
  } = state;

  return {
    coins,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    onUpdateUserCoins: updateUserCoins,
  },
  dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(UserSection);
